import { CircleDashed, Eye, CircleCheck, Pencil, Hourglass, TriangleAlert, Info } from 'lucide-react';
import Icon from './Icon';
import { CONDITIONS } from './stages';

const GLYPHS = { progress: CircleDashed, review: Eye, ready: CircleCheck, revision: Pencil, notready: Hourglass, incomplete: TriangleAlert };
const TONE_GLYPH = { info: Info, ok: CircleCheck, warn: TriangleAlert, danger: TriangleAlert };

// §2.6 Badge: the four conditions. Pass a condition name (tone and glyph follow §2.1), or tone + children
// for a real state that is not a script condition (e.g. "Ready" on a cut list).
export default function Badge({ condition, tone, icon, children }) {
  const c = condition ? CONDITIONS[condition] : null;
  const t = c ? c.tone : tone || 'info';
  const glyph = icon || (c ? GLYPHS[c.icon] : TONE_GLYPH[t]);
  return (
    <span className={`ui ui-badge ui-badge--${t}`}>
      <Icon icon={glyph} />
      <span>{condition || children}</span>
    </span>
  );
}
